export const MissingReferenceCountryProductErrorMessage = 'Export requires at least one reference country product';
export const OnlyOneProductPerCountryErrorMessage = 'Export requires at most one product for each country';
export const MissingNonSlovakProductErrorMessage = 'Export required at least one non slovak product';
export const MissingPackageSizeErrorMessage = 'Please enter package size for calculation';
export const MissingProductSettingsErrorMessage =
	'Some product settings are missing, please check that all fields are filled in';
export const MissingProductErrorMessage = 'Export requires at least one product';
export const MissingReferenceSettingsErrorMessage =
	'Some reference settings are missing, please check that all fields are filled in';
export const MissingCzReimbursementReferenceErrorMessage =
	'Please enter package size, dosage strength, ODTD (Obvyklá Denní Terapeutická Dávka) and ODTDBAL for calculation';
export const IllegalPriceTypeSelectedErrorMessage =
	'Product reference prices has changed, please check selected product prices';
export const MissingProductListErrorMessage =
	"The folder you're trying to export is empty. Please first create product lists with products and then you can export this folder.";
export const ExportB1RequiresReferenceCountriesErrorMessage = 'Export requires at least one reference country product';
export const RequiresAtMostOneRomanianProductForEachDatasource =
	'Export requires at most one Romanian product for each data source';
export const LimitExceededMessage =
	"Due to technical limitations it's not currently possible to export group with such number of products. Please split group to smaller ones.";
export const MissingThreeReferenceCountryProductsMessage = 'Export requires at least three reference country products';
export const LpCnRefExportContainsSlovakPzluProduct =
	'CNRef LP Export contains Slovak DP product. To export CNRef for LP, remove the DP product from the list.';
export const PzluCnRefExportContainsSlovakLpProduct =
	'CNRef DP Export contains Slovak LP product. To export CNRef for DP, remove the LP product from the list.';
